module.exports = __webpack_public_path__ + "static/media/android-api.cd615c69.md";